import { defa } from 'defa-object';
import ControlModel    from 'scripts/poppet/control-model';

/**
 * defa.models.WarmupState
 * The DEFA WarmupState model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	warmup: '/warmUp/warmUp?attrs=',
};

const WarmupState = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('id') + api.warmup + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
		{
			mainsConnected: null,
			heatingTimer: null,
			exteriorTemperature: null,
			interiorTemperature: null,
		}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	parse: function( response ) {
		if ( response ) {
			response.modelError = null;
			this.receivedData( response );
			channel.request( 'warmupStates' ).add( response, { merge: true } );
		}
	},

	getAttributes: function () {
		return 'mainsConnected,heatingTimer,exteriorTemperature,interiorTemperature';
	}
	
});

export default WarmupState;
